import type { Member, MemberRole } from '../types';
import { apiFetch } from './api';
import { adminPinDelete } from './admin-pin-client';

interface MembersResponse {
  ok: boolean;
  members: Member[];
}

interface MemberResponse {
  ok: boolean;
  member: Member;
}

export interface MemberUpdatePayload {
  name?: string;
  phone?: string | null;
  role?: MemberRole;
  lmNumber?: string | null;
}

export async function fetchMembers(): Promise<Member[]> {
  const res = await apiFetch<MembersResponse>('/api/members');
  return res.members;
}

export async function fetchMember(uid: string): Promise<Member> {
  const res = await apiFetch<MemberResponse>(`/api/members/${encodeURIComponent(uid)}`);
  return res.member;
}

export async function updateMember(uid: string, patch: MemberUpdatePayload): Promise<Member> {
  const res = await apiFetch<MemberResponse>(`/api/members/${encodeURIComponent(uid)}`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
  return res.member;
}

export async function deleteMember(uid: string, pin: string): Promise<void> {
  await apiFetch(`/api/members/${encodeURIComponent(uid)}`, adminPinDelete(pin));
}
